import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';
import Select2Forms from '../../js/components/select';
const FieldSelect = ({ isValid, options, showPlaceholder, name, label, register, setValue, }) => {
    const { t } = useTranslation();
    const optionRef = useRef(null);
    useEffect(() => {
        const selectContainer = optionRef.current.parentElement.parentElement;
        const select = optionRef.current.parentElement;
        const $selectContainer = $(selectContainer);
        Select2Forms.init($selectContainer);
        $selectContainer.on('select2:select select2:unselect', () => {
            const $select = $(select);
            setValue(name, $select?.val(), { shouldValidate: true });
        });
    }, []);
    return (_jsxs("select", { id: name, defaultValue: '', className: `custom-select select2-hidden-accessible ${!isValid ? 'is-invalid' : ''} ${showPlaceholder ? 'show-placeholder' : ''}`, "data-placeholder": label, ...register, children: [_jsx("option", { ref: optionRef, value: "" }), options.map(option => (_jsx("option", { value: option.value, children: t(`store_locator.question.form.message_subject.${option.text}`) }, option.value)))] }));
};
export default FieldSelect;
